/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const updateRadioStatusModelSchema = z.object({
    "radioScheduled": z.boolean().describe("Запущено ли радио"),
"startDate": z.string().datetime({ offset: true }).describe("Дата начала (необязательное поле, когда hasStarted = false)").nullable().nullish(),
"endDate": z.string().datetime({ offset: true }).describe("Дата окончания (необязательное поле, когда hasStarted = false)").nullable().nullish(),
"sendNotificationTimeInMinutes": z.number().int().describe("Через сколько минут отправлять пуш о том, что радио скоро начнется"),
"needToSendNotification": z.boolean().describe("Нужно ли отправлять уведомления о прямом эфире")
    })